(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["subcollection-storelli"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    new Swiper(".swiper-container", {
      slidesPerView: 3.3,
      spaceBetween: 0,
      breakpoints: {
        768: {
          slidesPerView: 3.3,
          spaceBetween: 0,
        }
      }
    });
  });


  } catch(e) { console.error(e); }
})();
})();
